<template>
    <v-tabs hide-slider height="auto" class="v-tabs--primary tab--block">
        <v-tab exact to="/news/campaign">진행중인 캠페인</v-tab>
        <v-tab exact to="/news/campaign/ended">완료된 캠페인</v-tab>
    </v-tabs>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.v-tabs--primary {
    .v-tab {
        &:first-child {
            border-radius: 999px 0 0 999px;
        }
        &:last-child {
            border-radius: 0 999px 999px 0;
        }
    }
}
</style>